import React from "react";
import { Box, Button, Stack, Text } from "@origin-digital/ods-core";
import { navTo } from "@origin-digital/event-dispatcher";
import { IconChevronRightSmall } from "@origin-digital/ods-icons";
import { trackMoveInClick, trackDisconnectClick } from "./analytics";
import { content } from "./content";

const LinkButton = ({
  onClick,
  children,
}: {
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <Button
    variant="text"
    color="secondaryB"
    noTextPadding
    fullWidth
    size="small"
    component="label"
    onClick={onClick}
  >
    <Box
      display="flex"
      width="full"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      {children}
    </Box>
  </Button>
);

export const PropertySheetBottomLinks = ({
  closeSheet,
}: {
  closeSheet: () => void;
}) => {
  return (
    <Stack dividers={true} space="small">
      {/*Empty box used to create dividers and spacing for links in stack */}
      <Box />
      <LinkButton
        onClick={() => {
          trackMoveInClick();
          closeSheet();
          navTo.move();
        }}
      >
        <Text inline={true}>{content.moveIn}</Text>
        <IconChevronRightSmall
          color="neutralLight"
          variant="solid"
          size="xxsmall"
        />
      </LinkButton>
      <LinkButton
        onClick={() => {
          trackDisconnectClick();
          closeSheet();
          navTo.disconnect();
        }}
      >
        <Text align="left">{content.disconnect}</Text>
        <IconChevronRightSmall
          color="neutralLight"
          variant="solid"
          size="xxsmall"
        />
      </LinkButton>
      {/*Empty box used to create dividers and spacing for links in stack */}
      <Box />
    </Stack>
  );
};
